import React from 'react';
import { Phone, MessageCircle, Mail, FileText } from 'lucide-react';
import { topBarContacts, updates } from '../mock';

export default function TopBar() {
  return (
    <div className="w-full bg-[#0b3d5b] text-white text-[13px]">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-between gap-2">
        <div className="flex flex-wrap items-center gap-4">

          <a href="mailto:info@registerpoint.com" className="flex items-center gap-1.5 hover:text-orange-300 transition-colors">
            <Mail className="w-3.5 h-3.5" /> {topBarContacts.email}
          </a>
        </div>
        <a href="#" className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-1 rounded flex items-center gap-1.5 transition-colors">
          <FileText className="w-3.5 h-3.5" /> File Your ITR
        </a>
      </div>
      <div className="bg-[#082e46] border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-1.5 flex flex-wrap items-center gap-x-6 gap-y-1 text-xs text-white/80">
          <span className="font-semibold text-orange-300">Compliance Updates:</span>
          {updates.map((u, i) => (
            <a key={i} href={u.link} className="hover:text-white transition-colors whitespace-nowrap">
              {u.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
